export default {"PACKAGE_VERSION": "2.1.29579.0 (c7dc32c8)","UI_THEME": "polaris"}